import { Chip, Stack, Typography } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { ConfidenceLevel } from '../appearances/types';

const confidenceLabelMessage = defineMessage({
  id: 'logger.diarization.confidence',
  defaultMessage: 'Confianza',
});

const LEVEL_MESSAGES = {
  high: defineMessage({ id: 'audit.transcriptionScreen.high', defaultMessage: 'Alta' }),
  medium: defineMessage({ id: 'audit.transcriptionScreen.medium', defaultMessage: 'Media' }),
  low: defineMessage({ id: 'audit.transcriptionScreen.low', defaultMessage: 'Baja' }),
} as const;

const LEVEL_TONES: Record<ConfidenceLevel, 'success' | 'warning' | 'error'> = {
  high: 'success',
  medium: 'warning',
  low: 'error',
};

type ConfidenceBadgeProps = {
  level: ConfidenceLevel;
  /** Valor crudo (distance o confidence) mostrado con dos decimales. */
  score: number;
  /** Sin la etiqueta "Confianza" ni margen superior, para filas compactas. */
  inline?: boolean;
};

/** Chip coloreado de nivel de confianza, compartido por voz y rostro. */
export function ConfidenceBadge({ level, score, inline }: ConfidenceBadgeProps) {
  const chip = (
    <Chip
      size="small"
      color={LEVEL_TONES[level]}
      variant="outlined"
      label={
        <>
          <FormattedMessage {...LEVEL_MESSAGES[level]} />
          {' · '}
          {score.toFixed(2)}
        </>
      }
      sx={{ height: 24, '& .MuiChip-label': { px: 1 } }}
    />
  );

  if (inline) {
    return chip;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1.25 }}>
      <Typography variant="caption" color="text.secondary">
        <FormattedMessage {...confidenceLabelMessage} />
      </Typography>
      {chip}
    </Stack>
  );
}
